/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMusic = createReactComponent("outline", "music", "IconMusic", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M13 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-1" }], ["path", { "d": "M9 17v-13h10v13", "key": "svg-2" }], ["path", { "d": "M9 8h10", "key": "svg-3" }]]);

export { IconMusic as default };
//# sourceMappingURL=IconMusic.mjs.map
